import axiosInstance from './axiosInstance';
import { API_ROUTES } from './constants';

// Create a new coupon
export const createCoupon = async (couponData) => {
  try {
    const response = await axiosInstance.post(API_ROUTES.COUPONS.CREATE, couponData);
    return response.data;
  } catch (error) {
    console.error('Error creating coupon:', error);
    throw error;
  }
};

// Update an existing coupon
export const updateCoupon = async (couponId, updateData) => {
  try {
    const response = await axiosInstance.patch(`${API_ROUTES.COUPONS.UPDATE}/${couponId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating coupon:', error);
    throw error;
  }
};

// Get all coupons with optional query parameters
export const getCoupons = async (queryParams = {}) => {
  try {
    const params = {
      page: queryParams?.page || 1,
      search: queryParams?.search || '',
      sortBy: queryParams?.sortBy || 'createdAt',
      type: queryParams?.type || '',
    };

    const response = await axiosInstance.get(API_ROUTES.COUPONS.GET, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching coupons:', error);
    throw error;
  }
};

export const getCoupon = async (couponId) => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.COUPONS.GET_SINGLE_COUPON}/${couponId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching coupon:', error);
    throw error;
  }
};

// Delete one or multiple coupons
export const deleteCoupons = async (couponIds) => {
  try {
    const response = await axiosInstance.delete(API_ROUTES.COUPONS.DELETE, {
      data: {
        ids: couponIds // array of numbers, e.g., [1, 2, 3]
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting coupons:', error);
    throw error;
  }
};

const couponsApi = {
  createCoupon,
  updateCoupon,
  getCoupons,
  deleteCoupons,
};

export default couponsApi;